export const SET_STATE = "SET_STATE"
export const RESET_STATE = "RESET_STATE"
export const CLEAN_STATE = "CLEAN_STATE"

export const SET_INVOICE = "SET_INVOICE"
export const RESET_INVOICE = "RESET_INVOICE"